import { Basemap } from '@workspaces/types'

export function isGoogleMapsBasemap(option: Basemap.Basemap): boolean {
  return option.startsWith('GoogleMaps')
}

interface GoogleMapsKeyContext {
  isGoogleMapsConfigured: boolean
  isTesting: boolean
  isLocalhost: boolean
}

/**
 * Returns the key to load Google Maps with, or null when it must not be loaded.
 * A missing key only skips Google Maps on localhost and in testing; on a
 * deployed env it is a misconfiguration, so it throws.
 */
export function resolveGoogleMapsApiKey(
  apiKey: string | undefined,
  { isGoogleMapsConfigured, isTesting, isLocalhost }: GoogleMapsKeyContext,
): string | null {
  if (!isGoogleMapsConfigured) {
    return null
  }
  if (apiKey) {
    return apiKey
  }
  if (!isTesting && !isLocalhost) {
    throw new Error(
      'VITE_GOOGLE_MAPS_API_KEY is not set, but Google Maps is configured as a basemap',
    )
  }
  console.warn(
    '🟥 Google Maps: not loaded (VITE_GOOGLE_MAPS_API_KEY is not set)',
  )
  return null
}
